import { Component } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import * as Chartist from 'chartist';
import { Observable } from 'rxjs/Observable';

declare var $: any;
@Component({
  selector: 'icons-cmp',
  moduleId: module.id,
  templateUrl: 'icons.component.html'
})

export class IconsComponent {

  image_folders: AngularFireList<any>;
  folder: AngularFireList<any>;
  items: Observable<any[]>;
  img: Observable<any[]>;

  usersRef : AngularFireList<any>;
  usersfire: Observable<any[]>;

    //pictures
  //  users= [];
    userLength;



  pictureLength;
  uniqueDates;
  pictures = [];
  series = [];
  sendLength = 0;
  notSendLength = 0;
    
  constructor(public db: AngularFireDatabase) {
   
    this.image_folders = db.list('pictures');

    this.items = this.image_folders.snapshotChanges();
    this.items.subscribe(pictures =>{
        this.pictures = [];
        var dates =[];
        var stores = [];
        var mailed = [];
      
        this.pictureLength = pictures.length;
        //console.log(pictures.length);

        for(var i=0; i < pictures.length ; i ++){
            //console.log(pictures[i])
             const   pic = pictures[i].payload.val();
            // console.log(pic);
             
            this.pictures.push({
                key : pictures[i].key,
                createdAt: pic.createdAt,
                file: pic.file,
                mailed: pic.mailed ,
                url:  pic.url,
                store: pic.storeName,
                date: (new Date(pic.createdAt)).toDateString()
            })
            dates.push((new Date(pic.createdAt)).toDateString());
            mailed.push(pic.mailed);
          }
          this.uniqueDates = this.unique(dates);
          this.makeSeries(this.pictures);
          this.count()

          var dataSales = {
            labels: this.uniqueDates,
            series: this.series
          };

    var optionsSales = {
      low: 0,
      high: 300,
     showArea: true,
      height: "245px",
      axisX: {
        showGrid: false,
      },
      lineSmooth: Chartist.Interpolation.simple({
        divisor: 3
      }),
      showLine: true,
      showPoint: true,
    };

    var responsiveSales = [
      ['screen and (max-width: 640px)', {
        axisX: {
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }
      }]
    ];

    Chartist.Line('#chartHours', dataSales, optionsSales, responsiveSales);

        });

        this.usersRef = db.list('users');
        this.usersfire = this.usersRef.snapshotChanges();
        this.usersfire.subscribe(users =>{
     //       this.users = [];
            this.userLength = users.length;
            console.log(users.length);
           var optInTrue = 0;
            var optInFalse = 0;
    
            for(var i=0; i < users.length ; i ++){
                console.log(users[i])
                 const   user = users[i].payload.val();

                  if(user.optIn == true){
                    optInTrue++;
                  }else{
                      optInFalse++;
                  }


                
               
              //  this.usersLoader =false;
            }
              console.log(optInTrue, optInFalse);

              var data = {
                series: [optInTrue,optInFalse]
              }
              var sum = function(a, b) { return a + b };

            Chartist.Pie('#chartPreferences',data,{ labelInterpolationFnc: function(value){
               return Math.round( value / data.series.reduce(sum) * 100) + '%';
            }
          });
            });
  }
  ngOnInit() {
   /**
    var dataPreferences = {
      series: [
        [25, 30, 20, 25]
      ]
    };

    var optionsPreferences = {
      donut: true,
      donutWidth: 40,
      startAngle: 0,
      total: 100,
      showLabel: false,
      axisX: {
        showGrid: false
      }
    };

    Chartist.Pie('#chartPreferences', dataPreferences, optionsPreferences);

    Chartist.Pie('#chartPreferences', {
      labels: ['62%', '32%', '6%'],
      series: [62, 32, 6]
    });
     */
  }
  makeSeries(array){
    this.series = [];
    var p = [];
    var psc = [];
    var pnsc = [];

    for(var i=0; i <this.uniqueDates.length; i++){
      var pictureCount = 0;
      var pictureSendCount =0;
      var pictureNotSendCount = 0;
      console.log(this.uniqueDates[i]);
      array.forEach(picture=>{
       // console.log(picture);
       // console.log(picture.date  == this.uniqueDates[i])
        if(picture.date  == this.uniqueDates[i]){
              pictureCount ++;
        }
         if(picture.date == this.uniqueDates[i] && picture.mailed == true){
              pictureSendCount ++;
        }
         if((picture.date == this.uniqueDates[i] && picture.mailed == false) || (picture.date == this.uniqueDates[i] && picture.mailed == undefined)){
            pictureNotSendCount ++;
        }
        //console.log(pictureCount, pictureSendCount, pictureNotSendCount);
    })
     p.push(pictureCount);
     psc.push(pictureSendCount);
     pnsc.push(pictureNotSendCount);
     console.log(p , psc, pnsc);
    }
    this.series[0] = p;
   this.series[1] = psc;
  // this.series[1] = pnsc;
    console.log(this.series);
   
  }

  unique(array) {
    var arr = [];
    for(var i = 0; i < array.length; i++) {
        if(arr.indexOf(array[i]) == -1) {
            arr.push(array[i]);
        }
    }
    return arr; 
}
count(){
  this.sendLength = 0;
  this.notSendLength = 0;
  var countp = 0;
  var countn = 0;
  this.pictures.forEach(picture =>{
          if(picture.mailed){
             countp ++;    
          }
          else if(!picture.mailed){
              countn ++;    
          }

  })
  this.sendLength = countp;
  this.notSendLength = countn;
  console.log(this.sendLength);
  console.log(this.notSendLength);
}
}




// WEBPACK FOOTER //
// /Users/makebetter/Documents/sportsceneDash/src/app/icons/icons.component.ts